package io.eqoty.shared.datalayer.objects

data class AttachmentEndpoint(val hash: String, val key: AesCredentials?)